<template>
  <DialogLayout :class-name="'confirm-dialog'" @close="handleClose" :style="{
    width: width + 'px'
  }">
    <template #title>{{ t('job.dialog.batchOpenToAgent.title') }}

    </template>
    <template #default>
      <div class="open-title">
        
        <LocaleSentence :text="t('job.dialog.batchOpenToAgent.description')">
          <template #count>
            <span class="table-stats-primary">{{ props.jobIds?.length || 0 }}</span>
          </template>
        </LocaleSentence>
      <!-- {{ t('job.dialog.batchOpenToAgent.description', { count: props.jobIds?.length || 0 }) }} -->
    </div>
      <el-form ref="formRef" :model="formData" :rules="rules" class="open-form" :hide-required-asterisk="true">
        <el-form-item prop="agents" :label="t('job.dialog.batchOpenToAgent.label')" class="form-item">
          <el-select v-model="formData.agents" multiple class="form-select">
            <el-option
              v-for="agent in agentList"
              :key="agent.value"
              :label="agent.label"
              :value="agent.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button
        type="default"
        class="confirm-button confirm-button-default"
        @click="handleCancel"
      >
        {{ t('common.cancel') }}
      </el-button>
      <el-button
        class="confirm-button"
        type="primary"
        @click="handleConfirm"
      >
        {{ t('common.save') }}
      </el-button>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, reactive } from 'vue';
import type { ConfirmModalProps } from './confirm-types';
import type { FormInstance, FormRules } from 'element-plus';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import {
  getHeadhuntingCompanySelectors,
  jobHeadhuntingOpen
} from '@/api/headhunting';
import LocaleSentence from '@/components/basic-components/locale-sentence/index.vue';
const { t } = useI18n()

interface BatchOpenToAgentProps extends ConfirmModalProps {
  jobIds?: number[];
  width?: number;
}

const props = withDefaults(
  defineProps<BatchOpenToAgentProps>(),
  {
    title: '提示',
    showClose: true,
    width: 560,
  }
);

const emit = defineEmits<{
  cancel: [data?: any];
  confirm: [data?: any];
  close: [data?: any];
}>();

const formRef = ref<FormInstance>();
const formData = reactive({
  agents: [] as number[]
});

const agentList = ref([
  {label: 'Z Venture Capital株式会社', value: 1},
  {label: 'Z Venture (株)LINC_agent', value: 2},
  {label: 'Z エージェント エージェント', value: 3},
]);

const rules: FormRules = {
  agents: [
    {
      required: true,
      message: t('job.dialog.batchOpenToAgent.selectAgentRequired'),
      trigger: ['change', 'blur'],
      type: 'array',
      min: 1
    }
  ]
}

const handleCancel = async () => {
  let result: any = undefined;
  if (props.cancelButton !== false && props.cancelButton?.onClick) {
    result = await props.cancelButton.onClick();
  }
  emit('cancel', result);
};

const handleConfirm = async () => {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
  } catch (error) {
    return;
  }

  if (!props.jobIds || props.jobIds.length === 0) {
    // ElMessage.warning(t('job.dialog.batchOpenToAgent.selectJobRequired'));
    return;
  }

  try {
    await jobHeadhuntingOpen({
      jobIds: props.jobIds,
      headhuntingCompanyIds: formData.agents
    });
    ElMessage.success(t('job.dialog.batchOpenToAgent.success'));
    emit('confirm', formData.agents);
  } catch (error) {
    ElMessage.error(t('job.dialog.batchOpenToAgent.failed'));
  }
};

const handleClose = () => {
  emit('close');
};
onMounted(() => {
  getHeadhuntingCompanySelectors().then(res => {
    agentList.value = res.map(item => {
      return {
        label: item.name,
        value: item.id,
        ...item,
      }
    });
  })
})
</script>

<style lang="scss" scoped>
.confirm-dialog {
  min-width: 509px;
  background: #ffffff;
  // border-radius: 8px;
  overflow: hidden;
}

.open-title {
  font-size: 14px;
  line-height: 22px;
  color: #495057;
  word-break: break-word;
  white-space: pre-line;
}
.open-form {
  margin-top: 20px;

  :deep(.form-item) {
    .el-form-item__label {
      font-size: 14px;
      font-weight: 500;
      line-height: 35px;
      color: #495057;
      padding-right: 20px;
    }

    .el-form-item__content {
      flex: 1;
    }
  }

  .form-select {
    width: 100%;
    :deep(.el-select__wrapper) {
      padding: 9px 12px;
    }
    :deep(.el-select__selected-item .el-tag) {
      background: #F4EFFD;
      border-radius: 4px;
    }
  }
}
.confirm-button {
  min-width: 72px;
  height: 35px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 22px;
  // border-radius: 4px;
  // border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;

  &:active {
    transform: translateY(1px);
  }
}
.confirm-button:not(.is-plain) {
  // border: 1px solid transparent;
}
.confirm-button-default {
  background: #ffffff;
  // border: none;
  color: #495057;
  font-weight: normal;
  cursor: pointer;
  &:hover {
    color: var(--el-color-primary);
  }
}


.confirm-button-danger {
  background: var(--el-color-danger);
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background: var(--el-color-danger);
  }
}

.confirm-button-success {
  background: var(--el-color-success);
  color: #ffffff;

  &:hover {
    background: var(--el-color-success);
  }
}

.confirm-button-warning {
  background: var(--el-color-warning);
  color: #ffffff;

  &:hover {
    background: var(--el-color-warning);
  }
}
</style>
